var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderAdd = function SvgFolderAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M3.1 3c0-1.05.85-1.9 1.9-1.9h8.586c.504 0 .987.2 1.343.557l5.415 5.414a1.9 1.9 0 0 1 .556 1.343V21a1.9 1.9 0 0 1-1.9 1.9H5A1.9 1.9 0 0 1 3.1 21zM5 2.9a.1.1 0 0 0-.1.1v18a.1.1 0 0 0 .1.1h14a.1.1 0 0 0 .1-.1V8.414a.1.1 0 0 0-.03-.07l-5.413-5.415a.1.1 0 0 0-.071-.029z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M11.1 14.9V18h1.8v-3.1H16v-1.8h-3.1V10h-1.8v3.1H8v1.8z"
  })));
};
export default SvgFolderAdd;